import React, { useState, useEffect } from "react";
import upArrow from "../../assets/icons/upArrow.png";
import { Button, CircularProgress } from "@material-ui/core";
import styles from "./RateCard.module.css";
import useResizer from "../../services/useResizer";

export default function RateCard({
  item,
  i,
  currentCoin,
  filteredCoinData,
  months,
  coinIcons,
  dictMonth,
  handleCoinClick,
  handleMonths,
  arr,
}) {
  const [rateOpen, setRateOpen] = useState(false);
  const isMobile = useResizer();

  useEffect(() => {
    if (i == 0) {
      setRateOpen(true);
    }
  }, []);
  useEffect(() => {
    currentCoin !== item && setRateOpen(false);
  }, [currentCoin]);
  return (
    <div key={i} className="md:px-5 px-2 select-none" id={item}>
      <div
        className={`w-full ${i == arr.length - 1 && "mb-6"} `}
        style={{ borderBottom: "1px solid #ffffff0d" }}
      >
        <div
          className={`w-full flex justify-between items-center py-3 px-2 cursor-pointer ${styles.tap}`}
          onClick={() => {
            handleCoinClick(item);
            setRateOpen(!rateOpen);
          }}
        >
          <div className="flex items-center gap-x-2">
            {" "}
            <img
              src={coinIcons[item]?.activeIconUrl}
              height="auto"
              width={20}
              alt={item}
            />
            <h3 className="text-[14px] font-medium text-[#E0E0E0] leading-[24px]">
              {coinIcons[item]?.coinName}
            </h3>
            <p className="text-[14px] font-medium text-[#9E9E9E] leading-[24px]">
              {coinIcons[item]?.coinId}
            </p>
            {i == 0 && (
              <div className="text-[12px] font-normal text-[#44CBB3] bg-[#44cbb31f] px-[6px] py-[2px] rounded-xl">
                Highest APY
              </div>
            )}
          </div>
          <div className="flex items-center gap-x-4">
            {!rateOpen && (
              <div className="text-[8px] md:text-[12px] font-normal text-[#FFC75B] bg-[#ffc75b1f] px-[5px] py-[2px] rounded-xl w-[30px] md:w-[50px] flex items-center justify-center ">
                {filteredCoinData[item]?.["lendData"]?.find(
                  (itm) =>
                    dictMonth[itm.tenure].replace(" Vault", "") == "1 Year",
                )?.rate + "%"}
              </div>
            )}
            <Button
              className="min-w-max px-[10px] py-3 bg-[#ffffff0a]"
              //   onClick={() => {
              //     handleCoinClick(item);
              //     setRateOpen(!rateOpen);
              //   }}
            >
              <img
                src={upArrow}
                height="auto"
                width={13}
                alt="down"
                className={`${
                  !rateOpen && "rotate-180"
                } transition-transform ease duration-300`}
              />
            </Button>
          </div>
        </div>
        {rateOpen && currentCoin === item && (
          <div
            className={`flex items-center justify-between gap-x-2 mb-4 px-2 2xl:px-6 w-full overflow-x-auto ${styles.hidescroll}`}
          >
            {filteredCoinData[item]?.["lendData"].map((item, i) => (
              <div
                onClick={() => {
                  handleMonths(item.tenure);
                }}
                key={item.id}
                className={`flex items-center justify-center gap-y-1 flex-col md:flex-1 py-2 2xl:py-4 rounded-lg bg-[#292D38] } cursor-pointer min-w-[110px] md:mim-w-auto ${styles.tap}`}
                style={{
                  boxShadow:
                    item.tenure == months && ".5px .5px 10px #42C1AB2f",
                  border:
                    item.tenure == months
                      ? "solid 1.3px #42C1AB"
                      : "solid 1px #2F3645",
                  transition: "border-color .6s ease",
                }}
              >
                {/* <EmptyTransparentCard lend outline={ele.tenure === months}>
                    <SingleItem lend text={dictMonth[ele.tenure]} />
                  </EmptyTransparentCard> */}
                <h1
                  className={`${
                    item.tenure == months && !isMobile
                      ? "text-[16px]"
                      : "text-[14px]"
                  } font-bold leading-[24px] text-[#44CBB3]`}
                >
                  {item.rate + "% APY"}
                </h1>
                <h3 className="text-[12px] font-normal text-[#FFFFFF]">
                  {dictMonth[item.tenure].replace("Vault", "")}
                </h3>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
